import env from '@/env';
import { Environment } from '@/types/environment';
import { initialiseErrorMonitoring } from '@/utils/errorMonitoring';

const viteEnv = env.VITE_NODE_ENV as Environment;
const nodeEnv: Environment = ['development', 'staging', 'production', 'test'].includes(viteEnv)
  ? viteEnv
  : 'development';

export const useErrorMonitoring = () => {
  initialiseErrorMonitoring(nodeEnv);
};
